import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores';
import { useAuthCheck } from '@/hooks/useAuthCheck';
import { ROUTES } from './routes';
import { LoadingScreen } from '@/components/feedback/LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthStore();
  
  // Trigger auth check on mount
  useAuthCheck();
  
  // Show loading screen while checking auth
  if (isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }
  
  return <>{children}</>;
}
